module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"weight":{"label":"Weight","placeholder":"Min = 0.1 kg | Max = 60 kg","hint":"Set this weight to all products in this page"}},"id":{"weight":{"label":"Berat","placeholder":"Min = 0.1 kg | Maks = 60 kg","hint":"Terapkan berat ini untuk semua produk di halaman ini"}}}')
  delete Component.options._Ctor
}
